import React from 'react';
import { VstButton } from 'vstui';

const baseCssClass = 'read-offline-chromebook';
class ReadOfflineChromebook extends React.Component {

  constructor() {
    super();
    this.state = {
      isLoading: true,
      webkey: null,
      hasError: false,
      hasCopied: false,
    };

    this._getActivationToken = this._getActivationToken.bind(this);
    this._getActivationTokenSuccess = this._getActivationTokenSuccess.bind(this);
    this._downloadApp = this._downloadApp.bind(this);
    this._copyWebkey = this._copyWebkey.bind(this);
  }

  componentDidMount() {
    this._getActivationToken();
  }

  _getActivationToken() {
    const url = `https://${Fraction.Helpers.getCurrentBrandUrl()}`;
    Jigsaw.User.requestActivation(url, this._getActivationTokenSuccess);
  }

  _getActivationTokenSuccess(response) {
    const userData = response.data.user;
    if (response.message || !userData.activation_token) {
      this.setState({
        isLoading: false,
        hasError: true
      });
    } else {
      this.setState({
        isLoading: false,
        webkey: userData.activation_token
      });

      const persistObject = Fraction.Helpers.getDataObject("User.Persist");
      persistObject.activationToken = userData.activation_token;
      Fraction.Helpers.savePersist();
    }
  }

  _downloadApp(e) {
    e.preventDefault();
    Fraction.Helpers.downloadApp();
    Fraction.Reporter.gaEvent("V3/read-offline", "", "downloadApp");
  }

  _copyWebkey(e) {
    e.preventDefault();
    if (!this.state.hasCopied) {
      Fraction.Helpers.copyText(this.state.webkey);
      this.setState({
        hasCopied: true
      });
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <div className={baseCssClass}>
          <p>{i18n.t('read-offline-chromebook.loading')}</p>
          <div className="spinner-container">
            <div className="spinning"/>
          </div>
        </div>
      );
    } else if (this.state.hasError) {
      return (
          <div>{i18n.t('read-offline-chromebook.has-error')}</div>
      );
    } else {
      return (
        <div className={baseCssClass}>
          <ol className="chromebook-keycode-items">
            <li><a href="#" onClick={this._downloadApp}>{i18n.t('read-offline-chromebook.install-app')}</a>.</li>
            <li>
              <p>{i18n.t('read-offline-chromebook.web-key-instructions')}</p>
              <p>{this.state.webkey}</p>
            </li>
          </ol>
          {Fraction.Helpers.copyEnabled() &&
            <VstButton options="btn-32" onClick={this._copyWebkey}>
              {i18n.t('read-offline-chromebook.copy-web-key')}
            </VstButton>
          }
          {this.state.hasCopied && <span>&nbsp;&nbsp;{i18n.t('read-offline-chromebook.copied-web-key')}</span>}
        </div>
      );
    }
  }

};

export default ReadOfflineChromebook;
